import React from 'react';

require('style/ConfigPrint');

export default class ConfigPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.setValue(this.props.config);
  }

  componentWillReceiveProps(props) {
    if (document.activeElement !== this.refs.textarea) {
      this.setValue(props.config);
    }
  }

  setValue(value) {
    this.setState({value: value ? JSON.stringify(value, null, 2) : ''});
  }

  validate() {
    try {
      const config = JSON.parse(this.state.value);
      this.setState({error: null});
      if (this.props.onChange) {
        this.props.onChange(config);
      }
    }
    catch(e) {
      this.setState({error: 'Invalid JSON: ' + e.message});
    }
  }

  render() {
    if (!this.props.config) {
      return null;
    }
    return (
      <div className="ConfigPrint">
        {this.state.error && <div className="error">{this.state.error}</div>}
        <textarea
          ref="textarea"
          value={this.state.value}
          onChange={(evt) => this.setState({value: evt.target.value})}
          onBlur={() => this.validate()}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/ConfigPrint.js